import { c as _c } from "react/compiler-runtime";
import type { ItemAdhesive } from "@sticker-giant/sg-frontend-common";
import { trackAdhesiveSelected } from "@/lib/analytics/segment";
import { useProduct } from "@/queries/useProduct";
import { usePdpStore } from "@/stores/usePdpStore";
import OptionRadioField from "./OptionRadioField";
import { useProductBuilderContext } from "./ProductBuilderContext";
import { useProductMicrocopy } from "./useProductMicrocopy";
import { useFieldErrorId } from "./ValidationError";
export default function Adhesive() {
  const $ = _c(19);
  const {
    product
  } = useProductBuilderContext();
  const {
    data: productAdmin
  } = useProduct(product.sku);
  const selectedAdhesive = usePdpStore(_temp);
  const selectedMaterial = usePdpStore(_temp2);
  const setAdhesive = usePdpStore(_temp3);
  const clearValidationError = usePdpStore(_temp4);
  const adhesiveErrorId = useFieldErrorId("adhesive");
  const adhesiveControlIdBase = `adhesive-${product.sku}`;
  const adhesiveLabelId = `${adhesiveControlIdBase}-label`;
  const adhesiveHelpDialogId = `${adhesiveControlIdBase}-help-dialog`;
  const microcopyFields = useProductMicrocopy();
  const adhesiveHelper = microcopyFields?.adhesiveHelper;
  const adhesiveLabel = microcopyFields?.adhesiveLabel ?? "Adhesive";
  const adhesiveValue = selectedAdhesive ?? productAdmin?.defaultAdhesive;
  const materialValue = selectedMaterial ?? productAdmin?.defaultMaterial;
  let t0;
  if ($[0] !== materialValue || $[1] !== productAdmin?.materialOptions) {
    t0 = productAdmin?.materialOptions.find(mat => mat.sku === materialValue);
    $[0] = materialValue;
    $[1] = productAdmin?.materialOptions;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const materialOption = t0;
  let t1;
  if ($[3] !== materialOption?.adhesiveOptions || $[4] !== productAdmin?.adhesiveOptions) {
    t1 = materialOption?.adhesiveOptions ?? productAdmin?.adhesiveOptions ?? [];
    $[3] = materialOption?.adhesiveOptions;
    $[4] = productAdmin?.adhesiveOptions;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const adhesiveOptions = t1;
  if (adhesiveOptions.length <= 1) {
    return null;
  }
  let t2;
  if ($[6] !== clearValidationError || $[7] !== setAdhesive) {
    t2 = value => {
      const adhesive = value as ItemAdhesive;
      setAdhesive(adhesive);
      clearValidationError("adhesive");
      trackAdhesiveSelected(adhesive);
    };
    $[6] = clearValidationError;
    $[7] = setAdhesive;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== adhesiveControlIdBase || $[10] !== adhesiveErrorId || $[11] !== adhesiveHelpDialogId || $[12] !== adhesiveHelper || $[13] !== adhesiveLabel || $[14] !== adhesiveLabelId || $[15] !== adhesiveOptions || $[16] !== adhesiveValue || $[17] !== t2) {
    t3 = <OptionRadioField field="adhesive" label={adhesiveLabel} helper={adhesiveHelper} controlIdBase={adhesiveControlIdBase} labelId={adhesiveLabelId} helpDialogId={adhesiveHelpDialogId} errorId={adhesiveErrorId} value={adhesiveValue} onValueChange={t2} options={adhesiveOptions} />;
    $[9] = adhesiveControlIdBase;
    $[10] = adhesiveErrorId;
    $[11] = adhesiveHelpDialogId;
    $[12] = adhesiveHelper;
    $[13] = adhesiveLabel;
    $[14] = adhesiveLabelId;
    $[15] = adhesiveOptions;
    $[16] = adhesiveValue;
    $[17] = t2;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  return t3;
}
function _temp4(state_2) {
  return state_2.clearValidationError;
}
function _temp3(state_1) {
  return state_1.setAdhesive;
}
function _temp2(state_0) {
  return state_0.material;
}
function _temp(state) {
  return state.adhesive;
}